import MojitoCore from 'mojito/core';
import TableLeagueImpl from './table-league.js';

const { UIPage } = MojitoCore.Presentation;

/**
 * TableLeague - league page pivot that renders the standings table and knockout bracket for the
 * league. The league type id corresponds to the tournament (league node) id used to subscribe to
 * the tournament data.
 *
 * @class TableLeague
 * @memberof Mojito.Applications.Sports.Pages
 */

export default UIPage('TableLeague', TableLeagueImpl);
